import React from "react";
import { Box, SxProps, Theme } from "@mui/material";
import { dtGreen } from "../../../shared/themes/redesignTokens";

// ===================================================================
//  LivePulseDot — animated green dot indicator for nav / badges
// ===================================================================

interface LivePulseDotProps {
  size?: number;
  color?: string;
  sx?: SxProps<Theme>;
}

const LivePulseDot: React.FC<LivePulseDotProps> = ({
  size = 8,
  color = dtGreen.green500,
  sx,
}) => {
  return (
    <Box
      sx={{
        position: "relative",
        width: size,
        height: size,
        flexShrink: 0,
        ...sx,
      }}
    >
      {/* Outer pulsing ring */}
      <Box
        sx={{
          position: "absolute",
          top: -(size * 0.5),
          left: -(size * 0.5),
          width: size * 2,
          height: size * 2,
          borderRadius: "50%",
          backgroundColor: color,
          opacity: 0.3,
          animation: "livePulse 1.5s ease-in-out infinite",
        }}
      />
      {/* Solid core dot */}
      <Box
        sx={{
          position: "relative",
          width: size,
          height: size,
          borderRadius: "50%",
          backgroundColor: color,
          zIndex: 1,
        }}
      />
    </Box>
  );
};

export default React.memo(LivePulseDot);
